module.exports = __webpack_public_path__ + "static/preparing-d84f53691636aacd1ee30b0499d8c2e4.gif";